import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autohide"
export default class extends Controller {
  static targets = ["message"];

  connect() {
    this.autoDismiss();
  }

  autoDismiss() {
    const duration = 3000;
    const permanent = this.data.get("permanent") === "true";

    if (!permanent) {
      setTimeout(() => {
        this.messageTargets.forEach((message) => {
          message.remove();
        });
      }, duration);
    }
  }
}
